import { Grid, Input, TextField, Typography } from "@mui/material";
import ConfirmModal from "components/Modals/ConfirmModal";
import FaiBox from "MuiComponents/FaiBox";
import FaiButton from "MuiComponents/FaiButton";
import { useState } from "react";
import Axios from "services/api/config";
import { toast } from "sonner";

const ContactMarchant = ({ onClose }) => {
	const [comment, setComment] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async () => {
		if (!comment) return toast.warning("Please Enter Comment!");

		setLoading(true);
		try {
			// const response = await Axios("/api/contact-marchant", {
			// 	method: "POST",
			// 	headers: {
			// 		"Content-Type": "application/json",
			// 	},
			// 	body: JSON.stringify({ comment }),
			// });
			// if (!response.ok) {
			// 	throw new Error(response.statusText);
			// }
			// const data = await response.json();
			// console.log("Form submitted successfully!", data);
		} catch (error) {
			console.error("Error submitting form:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<ConfirmModal
			title={
				<Typography variant="h5" className="!mt-2 !text-xl !font-medium">
					Contact Marchant
				</Typography>
			}
			handleCancel={onClose}
			visible={true}
			footer={false}
			body={
				<FaiBox>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<p className="font-bold mb-4">Order Id #631518</p>
							<TextField
								multiline
								rows={5}
								placeholder="Write a comment"
								fullWidth
								name="comment"
								value={comment}
								onChange={(e) => setComment(e.target.value)}
								// onBlur={handleBlur}
								// error={
								// 	touched.primaryContactNo && Boolean(errors.primaryContactNo)
								// }
								// helperText={touched.primaryContactNo && errors.primaryContactNo}
							/>
						</Grid>
						<Grid item xs={12}>
							<FaiButton color="dark" onClick={handleSubmit}>
								Sent to Marchant
							</FaiButton>
						</Grid>
					</Grid>
				</FaiBox>
			}
		/>
	);
};
export default ContactMarchant;
